import React, { Component, createRef } from 'react';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import authService from './api-authorization/AuthorizeService';
import { BaseComponent } from './base/BaseComponent';
import { Chart } from 'primereact/chart';
import { Toolbar } from 'primereact/toolbar';
import { Toast } from 'primereact/toast';


export class HomeUtilizatorPontaj extends Component {

    constructor(props) {
        super(props);

        this.toast = createRef();
        const idLocatie = props.match?.params?.idLocatie || -1;

        this.state = {
            infoPontaj: {},
            loading: false,
            idLocatie: idLocatie
        };
    }

    componentDidMount() {
        this.populatePontaj();
    }

    async populatePontaj() {
        var infoPontaj = await this.getInfoPontaj();
        this.setState({ infoPontaj: infoPontaj });
    }

    setLoading = (show) => {
        this.setState({ loading: show });
    }

    async getInfoPontaj() {
        var result = await authService.fetchAuth('TimeTrack/GetInfoPontaj', { id: this.state.idLocatie });
        return result;
    }

    doPontaj = async (type) => {
        if (!this.state.infoPontaj?.stockAdministration?.stockAdministrationId) {
            this.toast.current.show({ severity: 'warn', summary: 'Atentie', detail: 'Codul QR scanat nu este valid!', life: 3000 });
        }
        else {
            this.setLoading(true);

            try {
                let userLatitude = 0;
                let userLongitude = 0;

                // ia coordonatele telefonului
                try {
                    if (navigator.geolocation) {

                        const position = await new Promise((resolve, reject) => {

                            navigator.geolocation.getCurrentPosition(
                                resolve,
                                reject,
                                {
                                    enableHighAccuracy: true,
                                    timeout: 10000,
                                    maximumAge: 0
                                }
                            );

                        });

                        userLatitude = position.coords.latitude;
                        userLongitude = position.coords.longitude;
                    }

                } catch (geoError) {
                    userLatitude = 0;
                    userLongitude = 0;
                }
                //end

                const tt_LogTimeTrackInfo = {};
                tt_LogTimeTrackInfo.tt_LogTimeTrack = {};
                tt_LogTimeTrackInfo.tt_LogTimeTrack.locationId = this.state.infoPontaj?.stockAdministration?.stockAdministrationId;
                tt_LogTimeTrackInfo.tt_LogTimeTrack.locationLatitude = this.state.infoPontaj?.stockAdministration?.latitude ?? 0;
                tt_LogTimeTrackInfo.tt_LogTimeTrack.locationLongitude = this.state.infoPontaj?.stockAdministration?.longitude ?? 0;
                tt_LogTimeTrackInfo.tt_LogTimeTrack.userLatitude = userLatitude;
                tt_LogTimeTrackInfo.tt_LogTimeTrack.userLongitude = userLongitude;
                tt_LogTimeTrackInfo.tt_LogTimeTrack.type = type;

                const result = await authService.fetchAuth('TimeTrack/SaveTimeTrack', tt_LogTimeTrackInfo );

                //this.toast.current.show({ severity: 'success', summary: 'Success', detail: type + ' - Pontaj realizat cu succes!', life: 3000 }); 
                this.toast.current.show({
                    severity: userLatitude === 0 ? 'warn' : 'success',
                    summary: 'Pontaj',
                    detail:
                        userLatitude === 0
                            ? type + ' - Pontaj realizat fara locatie GPS'
                            : type + ' - Pontaj realizat cu succes!',
                    life: 3000
                });

                //reapelez populate ca sa se actualizeze ultimul pontaj
                this.setState({ idLocatie: -1 }, async () => { await this.populatePontaj(); });

            } catch (e) {
                this.toast.current.show({ severity: 'error', summary: 'Eroare', detail: 'Pontajul nu a putut fi salvat', life: 3000 });
            }

            this.setLoading(false);
        }
    }

    render() {
        const { infoPontaj, loading } = this.state;
        const numeAngajat = infoPontaj?.personInfo?.fullName || 'Nume Angajat';
        const functie = infoPontaj?.functie || 'Angajat';
        const numeLocatie = infoPontaj?.stockAdministration?.name || '######'
        const idLocatie = infoPontaj?.stockAdministration?.code || '######';
        const initiale = numeAngajat.trim().split(' ').filter(Boolean).map(p => p[0]).slice(0, 2).join('').toUpperCase();
        const ultimulPontaj = infoPontaj?.lastTimeTrackString || '######';
        const ultimulPontajTip = infoPontaj?.lastTimeTrack?.type;

        return (
            <div className="p-grid p-fluid">
                <Toast ref={this.toast} />
                <div className="p-col-12">
                    <div className="card">
                        <div className="p-col-12 p-md-4">
                            <div className="box p-shadow-5 pb-2">

                                {/* Header */}
                                <div style={{ background: '#2196F3', borderRadius: 6, margin: '0 0 12px 0', padding: '14px 16px', display: 'flex', alignItems: 'center', gap: 12 }}>
                                    <div style={{ width: 44, height: 44, borderRadius: '50%', background: '#015a8a', border: '2px solid #64b0d4', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, fontWeight: 700, color: '#fff', flexShrink: 0 }}>
                                        {initiale}
                                    </div>
                                    <div>
                                        <div style={{ fontSize: 15, fontWeight: 600, color: '#fff' }}>{numeAngajat}</div>
                                        {functie && <div style={{ fontSize: 12, color: '#a8d4ea', marginTop: 2 }}>{functie}</div>}
                                    </div>
                                </div>

                                {/* Info locatie */}
                                <div className="pl-4 pr-4 pt-2" style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                                    <div style={{ background: '#e8f4fb', borderRadius: 6, padding: '8px 12px', display: 'flex', alignItems: 'center', gap: 10 }}>
                                        <i className="pi pi-map-marker" style={{ fontSize: 20, color: '#2196F3' }} />
                                        <div>
                                            <div style={{ fontSize: 11, fontWeight: 600, color: '#2196F3', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Locatie</div>
                                            <div style={{ fontSize: 14, fontWeight: 600, color: '#014d77' }}>{numeLocatie}</div>
                                        </div>
                                    </div>
                                    <div style={{ background: '#e8f4fb', borderRadius: 6, padding: '8px 12px', display: 'flex', alignItems: 'center', gap: 10 }}>
                                        <i className="pi pi-tag" style={{ fontSize: 20, color: '#2196F3' }} />
                                        <div>
                                            <div style={{ fontSize: 11, fontWeight: 600, color: '#2196F3', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Cod Locatie</div>
                                            <div style={{ fontSize: 14, fontWeight: 600, color: '#014d77' }}>{idLocatie}</div>
                                        </div>
                                    </div>
                                    <div style={{ background: '#e8f4fb', borderRadius: 6, padding: '8px 12px', display: 'flex', alignItems: 'center', gap: 10 }}>
                                        <i className="pi pi-clock" style={{ fontSize: 20, color: '#2196F3' }} />
                                        <div style={{ flex: 1 }}>
                                            <div style={{ fontSize: 11, fontWeight: 600, color: '#2196F3', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Ultimul pontaj</div>
                                            <div style={{ fontSize: 14, fontWeight: 600, color: '#014d77' }}>{ultimulPontaj}</div>
                                        </div>
                                        {ultimulPontaj != '######' && (
                                            <span style={{
                                                display: 'inline-flex', alignItems: 'center', gap: 5,
                                                background: ultimulPontajTip === 'IN' ? '#C6F0D6' : '#FADADD',
                                                color: ultimulPontajTip === 'IN' ? '#1A7A3A' : '#9B2222',
                                                borderRadius: 20, padding: '3px 10px',
                                                fontSize: 14, fontWeight: 600
                                            }}>
                                                <span style={{
                                                    width: 8, height: 8, borderRadius: '50%',
                                                    background: ultimulPontajTip === 'IN' ? '#2ECC71' : '#E74C3C',
                                                    display: 'inline-block'
                                                }} />
                                                {ultimulPontajTip}
                                            </span>
                                        )}
                                    </div>
                                </div>

                                {/* Butoane */}
                                <div className="pl-4 pr-4 mt-4 pb-3" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
                                    <button className="btn btn-success" style={{ height: 70, fontSize: 18, fontWeight: 700, borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10 }} onClick={() => this.doPontaj('IN')}>
                                        <i className="pi pi-sign-in" style={{ fontSize: 18 }} /> IN
                                    </button>
                                    <button className="btn btn-danger" style={{ height: 70, fontSize: 18, fontWeight: 700, borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10 }} onClick={() => this.doPontaj('OUT')}>
                                        <i className="pi pi-sign-out" style={{ fontSize: 18 }} /> OUT
                                    </button>
                                </div>
                                    
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

export default HomeUtilizatorPontaj;